import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as turf from '@turf/turf';

import SimpleHeading from '../../common/SimpleHeading';
import { AreaText } from '../../../../Common/UI/AreaText';
import { LengthText } from '../../../../Common/UI/LengthText';
import ScrollableContainer from '../../../../utility/ScrollableContainer';
import PointFeatureProperties from '../../draw/PointFeatureProperties';
import NewSketchesForm from './NewSketchesForm';
import DrawnSearchAreaInput from '../../common/searcharea/DrawnSearchAreaInput';

import { MAIN_MAP } from '../../../../../redux/map/Constants';

import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import _ from 'lodash';

const propTypes = {};

const defaultProps = {};

const useStyles = makeStyles(theme => styles(theme));

function NewSketchesBody() {
    const classes = useStyles();

    const drawModule = useSelector(state => state[MAIN_MAP].drawModule);
    const drawingFeature = useSelector(state => state[MAIN_MAP].drawingFeature);

    const featureIds = isDrawing
        ? [drawingFeature.properties.id]
        : drawModule.getDrawControl().getSelectedIds();
    const feature = drawingFeature || drawModule.getDrawControl().get(featureIds[0]);
    const isDrawing =
        drawingFeature &&
        !_.isEmpty(drawingFeature) &&
        drawingFeature.geometry.coordinates.length > 0 &&
        !drawModule.getDrawControl().getSelectedIds().includes(drawingFeature.id);

    let shapeText = '';
    const [toggleButtons, setToggleButtons] = useState('ha');

    function createInfoContent(feature) {
        if (feature?.geometry?.type === 'Polygon') {
            const area = turf.area(feature?.geometry);
            return <AreaText area={area} unit={toggleButtons} removeUnit={true} />;
        } else if (feature?.geometry?.type === 'LineString') {
            const distance = turf.lineDistance(feature?.geometry) * 1000;
            return <LengthText length={distance} />;
        } else if (feature?.geometry?.type === 'Point') {
            return <PointFeatureProperties feature={feature} />;
        }
    }

    const handleToggleButtons = (event, newToggleButtons) => {
        if (newToggleButtons !== null) {
            setToggleButtons(newToggleButtons);
        }
    };

    if (feature?.geometry?.type === 'Polygon') {
        shapeText = 'Area';
    } else if (feature?.geometry?.type === 'LineString') {
        shapeText = 'Length';
    } else if (feature?.geometry?.type === 'Point') {
        shapeText = 'Coordinates';
    }

    return (
        !isDrawing &&
        drawingFeature !== null && (
            <ScrollableContainer className={classes.root}>
                <SimpleHeading label="Shape measurements" />
                {feature?.properties?.radius && (
                    <DrawnSearchAreaInput
                        showArea={false}
                        disabled={feature?.properties?.isLocked ? true : false}
                    />
                )}

                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                        <Typography variant="body1" color="textPrimary">
                            {shapeText}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography
                            variant="body1"
                            color="textPrimary"
                            classes={{ root: classes.textPadding }}>
                            {createInfoContent(feature)}
                        </Typography>
                    </Grid>

                    <Grid item xs={3}>
                        {feature?.geometry?.type === 'Polygon' && (
                            <ToggleButtonGroup
                                value={toggleButtons}
                                exclusive
                                onChange={handleToggleButtons}>
                                <ToggleButton
                                    value={'ha'}
                                    classes={{ root: classes.toggleButtonText2 }}>
                                    ha
                                </ToggleButton>
                                <ToggleButton
                                    value={'km2'}
                                    classes={{ root: classes.toggleButtonText }}>
                                    km²
                                </ToggleButton>
                                <ToggleButton
                                    value={'ac'}
                                    classes={{ root: classes.toggleButtonText2 }}>
                                    ac
                                </ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    </Grid>
                </Grid>

                <NewSketchesForm feature={feature} />
            </ScrollableContainer>
        )
    );
}

const styles = theme => ({
    root: {
        padding: '20px 24px 24px 24px',
        '&> *:not(:last-child)': {
            marginBottom: theme.constants.verticalMargin
        }
    },
    textPadding: {
        paddingLeft: '14px'
    },
    toggleButtonText: {
        textTransform: 'none',
        padding: '0 8px',
        height: '40px'
    },
    toggleButtonText2: {
        textTransform: 'none',
        padding: '0 9px',
        height: '40px'
    }
});

NewSketchesBody.propTypes = propTypes;
NewSketchesBody.defaultProps = defaultProps;

export default NewSketchesBody;
